import { DocumentType } from 'support/types';
import { CreateInvoiceAndCreditNoteSummary } from 'components/WebEDI/CreateInvoiceAndCreditNoteSummary/CreateInvoiceAndCreditNoteSummary';
import { CreateShipmentSummary } from 'components/WebEDI/CreateShipmentSummary/CreateShipmentSummary';

export const CreateEditDocumentBottomBanner = ({ documentType }: { documentType: DocumentType | undefined }) => {
  switch (documentType) {
    case DocumentType.invoice:
    case DocumentType.creditNote:
      return <CreateInvoiceAndCreditNoteSummary documentType={documentType} />;
    case DocumentType.shippingNotice:
    case DocumentType.dispatchResponse:
      return <CreateShipmentSummary documentType={documentType} />;
    default:
      return null;
  }
};
